import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceRequestEconomy from './ServiceRequestEconomy'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'registration-information/economy',
    name:
        'serviceRequest.registration-information.economy',
    component: ServiceRequestEconomy,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }
]
